// extracted by mini-css-extract-plugin
export default {"pageSelectorContainer":"FaxPrintPageSelectionComponent_pageSelectorContainer__yAjE7"};